import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FormDisplayedService {
    private formDisplayedSubject = new BehaviorSubject<boolean>(false);
    formDisplayed$ = this.formDisplayedSubject.asObservable();

    constructor() {
    }

    setFormDisplayed(value: boolean) {
        this.formDisplayedSubject.next(value);
    }
}
